<template>
  <div class="overview-root" v-loading="isLoading">
    <div class="container-filter">
      <div class="container">
        <div class="icon-filter">
          <div
            class="filter"
            :class="{ active: filterOption.platform === 'all' }"
            @click="handleChangePlatform('all')"
          >
            <i class="iconfont icon-menu"></i>
          </div>
          <div
            v-for="(icon, index) in iconEnum"
            :key="icon + 'filter'"
            class="filter"
            :class="{
              active: filterOption.platform === platformEnum[index + 1],
            }"
            v-show="showFilter[index]"
            @click="handleChangePlatform(platformEnum[index + 1])"
          >
            <i :class="['iconfont', 'icon-' + icon]"></i>
          </div>
        </div>
        <div class="handle-filter">
          <el-button link type="primary" class="action-button">
            <router-link
              :to="{
                name: 'Apps',
                query: { action: 'new', project: currentProjectId },
              }"
            >
              <span>
                <i
                  class="iconfont icon-square-plus"
                  style="vertical-align: middle"
                ></i>
                创建新应用
              </span>
            </router-link>
          </el-button>
          <el-button link type="primary" class="action-button">
            <router-link
              :to="{ name: 'Apps', query: { project: currentProjectId } }"
            >
              <span>
                <i
                  class="iconfont icon-thlist"
                  style="vertical-align: middle"
                ></i>
                全部应用
              </span>
            </router-link>
          </el-button>
        </div>
      </div>
    </div>
    <div class="container-apps">
      <div class="panel-apps">
        <div v-if="appsShow.length === 0" class="noDatacss">
          <span>暂无数据！</span>
        </div>
        <div class="app" v-for="(app, index) in appsShow" :key="app.id">
          <div class="app-qrcode" v-if="app.showQrcode">
            <VueQrcode
              :value="generateDownloadUrl(app.uri)"
              :options="{ width: 210 }"
              style="margin-top: 80px"
            />
          </div>
          <div class="app-platform">
            <div class="background"></div>
            <i
              :class="[
                'platform',
                'iconfont',
                'icon-' + iconEnum[app.platform - 1],
              ]"
              :style="{
                color: iconColorEnum[app.platform - 1],
              }"
            ></i>
          </div>
          <div class="app-base">
            <div class="app-logo" @click="handleEnterDetail(app)">
              <img :src="app.logourl" width="60" />
            </div>
            <router-link
              :to="{
                name: 'Apps',
                query: {
                  action: 'detail',
                  project: currentProjectId,
                  appid: app.id,
                },
              }"
            >
              <el-tooltip placement="bottom">
                <template #content>
                  <div>{{ app.appname }}</div>
                </template>
                <div class="app-name">
                  {{ app.appname }}
                </div>
              </el-tooltip>
            </router-link>
            <table class="app-detail">
              <tr>
                <td class="label">包名称:</td>
                <td class="value">
                  <el-tooltip
                    effect="dark"
                    :content="app.packagename"
                    placement="top"
                  >
                    <span>{{ app.packagename }}</span>
                  </el-tooltip>
                </td>
              </tr>
              <tr>
                <td class="label">短链接:</td>
                <td class="value">
                  <el-button link type="primary" @click="handleCopy(app.uri)">{{
                    app.uri
                  }}</el-button>
                </td>
              </tr>
              <tr>
                <td class="label">版本号:</td>
                <td class="value">
                  {{
                    app.releaseversion
                      ? app.releaseversion.package.version
                      : "0.0.0"
                  }}
                </td>
              </tr>
              <tr>
                <td class="label">构建号:</td>
                <td class="value">
                  {{
                    app.releaseversion
                      ? app.releaseversion.package.buildnumber
                      : "000"
                  }}
                </td>
              </tr>
              <tr>
                <td class="label">更新于:</td>
                <td class="value">
                  {{ $moment(app.updatetime || app.createtime).fromNow() }}
                </td>
              </tr>
            </table>
          </div>
          <div class="actions">
            <div class="container-actions">
              <div
                class="qcode"
                @mouseover="handleShowQrcode(index, app)"
                @mouseout="handleHideQrcode(index, app)"
              >
                <i class="iconfont icon-qrcode"></i>
                <br />二维码
              </div>
              <div class="share" @click="handleOpenDownload(app.uri)">
                <i class="iconfont icon-share-square"></i>
                <br />分享
              </div>
              <div class="detail" @click="handleEnterDetail(app)">
                <i class="iconfont icon-leanpub"></i>
                <br />详情
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, getCurrentInstance, onMounted } from "vue";
import { storeToRefs } from "pinia";
import { useProjectStore } from "@/Store/ProjectStore";
import { useRouter } from "vue-router";
import VueQrcode from "@chenfengyuan/vue-qrcode";
import { getDownloadBaseUrl } from "@/Utils/UtilTools";

const { appContext } = getCurrentInstance();
const projectStore = useProjectStore();
const router = useRouter();

const $message = appContext.config.globalProperties.$message;
const $moment = appContext.config.globalProperties.$moment;
const $copyText = appContext.config.globalProperties.$copyText;

const { projectApps, loadingApps, currentProjectId } =
  storeToRefs(projectStore);
const isLoading = loadingApps;
const apps = ref([]);
const showFilter = ref([false, false, false, false, false]);
function clear() {
  apps.value = [];

  showFilter.value = [false, false, false, false, false];
}
watch(
  projectApps,
  async (list) => {
    getAppsFromStore(list);
  },
  { immediate: true }
);
onMounted(() => {
  getAppsFromStore(projectApps.value);
});
function getAppsFromStore(list) {
  if (!loadingApps.value) {
    apps.value = list;

    apps.value.forEach((app) => {
      app.showQrcode = false;

      // 种类过滤更新
      if (app.platform > 0 && !app.disabled) {
        showFilter.value.splice(app.platform - 1, 1, true);
      }
    });

    getShowApps();
  } else {
    clear();
  }
}

const iconColorEnum = [
  "rgba(124, 124, 124, 1)",
  "rgba(109, 194, 101, 1)",
  "rgba(0, 113, 213, 1)",
  "rgba(0, 163, 245, 1)",
  "rgba(0, 163, 245, 1)",
];
const iconEnum = ["apple", "android", "windows", "app-store", "linux"];
const platformEnum = ["all", "ios", "android", "windows", "mac", "linux"];
const appsShow = ref([]);
const filterOption = ref({
  platform: "all",
  active: false,
  query: "",
});
function getShowApps() {
  if (filterOption.value.active) {
    appsShow.value = apps.value.filter((app) => {
      if (!app.disabled) {
        if (platformEnum[app.platform] === filterOption.value.platform) {
          return true;
        }
      }
    });
  } else {
    appsShow.value = apps.value.filter((app) => {
      if (!app.disabled) {
        return true;
      }
    });
  }
}
function handleChangePlatform(val) {
  filterOption.value.platform = val;
  filterOption.value.active = val !== "all";

  getShowApps();
}

function handleShowQrcode(index, app) {
  app.showQrcode = true;
  appsShow.value.splice(index, 1, app);
}
function handleHideQrcode(index, app) {
  app.showQrcode = false;
  appsShow.value.splice(index, 1, app);
}

const baseUrl = getDownloadBaseUrl(router);
function handleOpenDownload(uri) {
  window.open(generateDownloadUrl(uri));
}
function generateDownloadUrl(uri) {
  return baseUrl + uri;
}
async function handleCopy(uri) {
  const content = generateDownloadUrl(uri);
  try {
    await $copyText(content);

    $message({
      message: "己复制链接到粘贴板",
      type: "success",
    });
  } catch (e) {
    $message({
      message: "复制失败",
      type: "error",
    });
  }
}

function handleEnterDetail(app) {
  router.push({
    name: "Apps",
    query: { action: "detail", project: currentProjectId.value, appid: app.id },
  });
}
</script>

<style lang="scss" scoped>
.overview-root {
  height: 100%;
  padding-top: 20px;
  overflow-y: auto;
}

.container-filter {
  margin: 0 0 30px 0;
  display: flex;
  justify-content: center;

  .icon-filter {
    color: #606266;
  }

  .container {
    width: calc(260px * 5 + 100px);
    border-bottom: 1px solid #dcdfe6;
    display: flex;
    justify-content: space-between;

    .filter {
      display: inline-block;
      font-size: 35px;
      padding: 0 18px;
      line-height: 56px;

      &:hover,
      &.active {
        border-bottom: 2px solid #409eff;
        color: #409eff;
        cursor: pointer;
      }

      i {
        font-size: 35px;
      }
    }

    .handle-filter {
      .action-button {
        margin-right: 15px;
        margin-top: 12px;
        font-size: 16px;
      }
    }
  }
}

.container-apps {
  display: flex;
  justify-content: center;

  .panel-apps {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    align-items: flex-start;
    text-align: center;
    width: calc(260px * 5 + 100px);

    .noDatacss {
      width: 100%;
      display: inline-block;
      text-align: center;
      margin-top: 100px;
    }

    .app {
      margin: 15px;
      padding: 20px;
      background: #fff;
      border: 1px solid #efefef;
      width: 250px;
      height: 345px;
      position: relative;
      text-align: center;
      z-index: 10;

      &:hover {
        box-shadow: 0 0 3px 3px #cacaca;
        cursor: default;
      }

      .app-qrcode {
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 40;
        height: 100%;
      }

      .app-platform {
        position: absolute;
        top: 0;
        right: 0;

        .background {
          position: absolute;
          top: 0;
          right: 0;
          border-width: 0 60px 60px 0;
          border-color: transparent #e9e9e9;
          border-style: solid;
          z-index: 1;
        }
        .platform {
          position: absolute;
          top: 6px;
          right: 6px;
          font-size: 24px;
          z-index: 888;
        }
      }

      .app-base {
        .app-logo {
          text-align: center;

          img {
            border-radius: 10px;
          }
        }

        .app-name {
          text-align: center;
          font-weight: 800;
          line-height: 25px;
          height: 25px;
          overflow: hidden;
          text-overflow: ellipsis;
          margin: 15px 0;
        }

        .app-detail {
          width: 100%;
          text-align: left;
          margin-bottom: 70px;
          font-size: 14px;

          tr {
            height: 25px;
          }

          .label {
            display: inline-block;
            width: 57px;
            color: #909399;
          }
          .value {
            overflow: hidden;
            text-overflow: ellipsis;
            width: 145px;
            display: inline-block;

            .el-button {
              padding: 0;
              height: auto;
            }
          }
        }
      }

      .actions {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        border-top: 1px solid #e2e2e2c0;

        .container-actions {
          display: flex;
          line-height: 20px;
          color: #696969;
          font-size: 12px;
          padding: 5px 0;
          justify-content: space-around;

          .qcode:hover,
          .share:hover,
          .detail:hover {
            cursor: pointer;
            color: #409eff;
          }
        }
      }
    }
  }
}
</style>
